import React from "react";
import Calendar from "../../Calendar";
import Tickets from "../../Tickets";
import Dashboard from "../../Dashboard/components/Dashboard";
import Service from "../../services";
import Terms from "../../Terms";
import InspectorAssign from "../../InspectorAssign";
import InspectorModule from "../../InspectorModule";
import InspectorSchedule from "../../InspectorModule/InspectorSchedule";
import Client from "../../Client";
import ClientDetail from "../../Client/detail";
import ClientCompliance from "../../Client/detail/components/AnnualCompliance";
import ClientTickets from "../../Client/detail/components/Tickets";
import BuildingDetail from "../../Client/detail/components/Units";
import UnitTickets from "../../Client/detail/components/UnitTickets";
import InspectorRole from "../../InspectorRole";
import LeadCompliance from "../../LeadCompliance";
import FireNotice from "../../FireNotice";
import FireNoticeCompliance from "../../Client/detail/components/FireNotice";
import ClientMessaging from "../../ClientMessaging";
import Buildings from "../../Buildings";
import ScheduleInspection from "../../ScheduleInspection";
import { HPDViolations, HPDTickets, HPDAffidavits, PendingRequests } from "../../HPD";
import ViolationDetail from "../../HPD/components/HPDViolations/components/Detail";
import Inspections from "../../Client/detail/components/Inspections";
import LL55 from "../../LL55";
import ClientBuildings from "../../Client/detail/components/ClientBuildings";
import Reports from "../../Reports";
import ComingSoon from "../../../components/ComingSoon";
import DocumentUpload from "../../DocumentUpload";

export default function Routes() {
  const role = JSON.parse(localStorage.getItem("userData"))?.role;
  if (role == "admin")
    return {
      element: <Dashboard />,
      //   errorElement: <RouterErrorPage />,
      children: [
        {
          path: "/home",
          element: <Calendar />,
        },
        {
          path: "/ticket",
          element: <Tickets />,
        },
        {
          path: "ticket/inspector-assign",
          element: <InspectorAssign />,
        },
        {
          path: "/schedule-inspection",
          element: <ScheduleInspection />,
        },
        {
          path: "/hpd/violations",
          element: <HPDViolations />,
        },
        {
          path: "/hpd/violations/:id",
          element: <ViolationDetail />,
        },
        {
          path: "/hpd/tickets",
          element: <HPDTickets />,
        },
        {
          path: "/hpd/affidavits",
          element: <HPDAffidavits />,
        },
        {
          path: "/hpd/pending-requests",
          element: <PendingRequests />,
        },
        {
          path: "/client",
          element: <Client />,
        },
        {
          path: "/client/:clientId",
          element: <ClientDetail />,
        },
        {
          path: "/client/:clientId/buildings",
          element: <ClientBuildings />,
        },
        {
          path: "/client/:clientId/compliance",
          element: <ClientCompliance />,
        },
        {
          path: "/client/:clientId/fire-notice",
          element: <FireNoticeCompliance />,
        },

        {
          path: "/client/:clientId/building/:buildingId",
          element: <BuildingDetail />,
        },
        {
          path: "/client/:clientId/building/:buildingId/unit/:unitId",
          element: <UnitTickets />,
        },
        {
          path: "/inspector",
          element: <InspectorModule />,
        },
        {
          path: "/inspector/:inspectorId",
          element: <InspectorSchedule />,
        },
        {
          path: "/service",
          element: <Service />,
        },
        {
          path: "/terms",
          element: <Terms />,
        },
        {
          path: "/lead-compliance",
          element: <LeadCompliance />,
        },
        {
          path: "/fire-notice",
          element: <FireNotice />,
        },
        {
          path: "/client-messaging",
          element: <ClientMessaging />,
        },
        {
          path: "/buildings",
          element: <Buildings />,
        },
        {
          path: "/client/:clientId/inspections",
          element: <Inspections />,
        },
        {
          path: "/ll55",
          element: <LL55 />,
        },
        {
          path: "/reports",
          element: <Reports />,
        },
        {
          path: "/document-upload",
          element: <DocumentUpload />,
        },
        // {
        //   path: "/parapet",
        //   element: <ComingSoon />,
        // },
        // {
        //   path: "/backflow-hpd-tickets",
        //   element: <ComingSoon />,
        // },
      ],
    };
  else if (role == "client")
    return {
      element: <Dashboard />,
      //   errorElement: <RouterErrorPage />,
      children: [
        // {
        //   path: "/parapet",
        //   element: <ComingSoon />,
        // },
        // {
        //   path: "/backflow-hpd-tickets",
        //   element: <ComingSoon />,
        // },
        {
          path: "/client/:clientId",
          element: <ClientDetail />,
        },
        {
          path: "/client/:clientId/compliance",
          element: <ClientCompliance />,
        },
        {
          path: "/client/:clientId/fire-notice",
          element: <FireNoticeCompliance />,
        },
        {
          path: "/client/:clientId/building/:buildingId",
          element: <BuildingDetail />,
        },
        {
          path: "/client/:clientId/building/:buildingId/unit/:unitId",
          element: <UnitTickets />,
        },
        {
          path: "/client/:clientId/tickets",
          element: <ClientTickets />,
        },
        {
          path: "/client/:clientId/inspections",
          element: <Inspections />,
        },
        {
          path: "/hpd/violations",
          element: <HPDViolations />,
        },
        {
          path: "/hpd/violations/:id",
          element: <ViolationDetail />,
        },
        {
          path: "/hpd/affidavits",
          element: <HPDAffidavits />,
        },
        {
          path: "/schedule-inspection",
          element: <ScheduleInspection />,
        },
        {
          path: "/buildings",
          element: <Buildings />,
        },
        {
          path: "/lead-compliance",
          element: <LeadCompliance />,
        },
        {
          path: "/ll55",
          element: <LL55 />,
        },
      ],
    };
  else if (role == "inspector")
    return {
      element: <Dashboard />,
      //   errorElement: <RouterErrorPage />,
      children: [
        {
          path: "/inspector-role",
          element: <InspectorRole />,
        },
      ],
    };
}
